/**
 * Les auteurs de Steve, et la façon de les reconnaître dans un texte.
 *
 * Ce sont **les seuls liens sortants du site**. Ils apparaissent au pied de
 * chaque skin, et aussi dans les textes de présentation qui les citent : on ne
 * nomme pas quelqu'un sans donner l'adresse où le trouver.
 *
 * La découpe est pure et sans DOM pour pouvoir être testée : le composant qui
 * l'utilise ne fait qu'habiller le résultat.
 */

export const AUTHORS = {
  Vigz: 'https://www.instagram.com/vigzvigz/?hl=fr',
  Tomo: 'https://www.youtube.com/@tomomp3',
} as const;

export type AuthorName = keyof typeof AUTHORS;

export type TextPart =
  | { readonly kind: 'text'; readonly text: string }
  | { readonly kind: 'author'; readonly name: AuthorName };

/** Les noms, dans un groupe capturant : le séparateur revient dans la découpe. */
const NAMES = new RegExp(`\\b(${Object.keys(AUTHORS).join('|')})\\b`, 'g');

function isAuthor(value: string): value is AuthorName {
  return Object.hasOwn(AUTHORS, value);
}

/**
 * Découpe un texte en morceaux ordinaires et en noms d'auteurs.
 *
 * La casse compte : « Tomo » est le musicien, « tomo » serait autre chose. Les
 * bornes de mot évitent d'attraper un nom au milieu d'un autre.
 */
export function splitAuthors(text: string): readonly TextPart[] {
  const parts: TextPart[] = [];
  let last = 0;

  for (const match of text.matchAll(NAMES)) {
    const name = match[0];
    if (!isAuthor(name)) continue;
    if (match.index > last) parts.push({ kind: 'text', text: text.slice(last, match.index) });
    parts.push({ kind: 'author', name });
    last = match.index + name.length;
  }

  if (last < text.length) parts.push({ kind: 'text', text: text.slice(last) });
  return parts;
}
